const DEFAULT_EXPERIMENT_NAME = "Custom Experiment";
const DEFAULT_FEATURE_EXPOSURE_DURATION = "0";
var ExperimentPivots = /* @__PURE__ */ ((ExperimentPivots2) => {
  ExperimentPivots2["details"] = "details";
  ExperimentPivots2["iterations"] = "iterations";
  ExperimentPivots2["log"] = "log";
  ExperimentPivots2["history"] = "history";
  ExperimentPivots2["alerts"] = "alerts";
  ExperimentPivots2["assignment"] = "assignment";
  return ExperimentPivots2;
})(ExperimentPivots || {});
var ExperimentViewConstants = /* @__PURE__ */ ((ExperimentViewConstants2) => {
  ExperimentViewConstants2["edit"] = "edit";
  ExperimentViewConstants2["iterate"] = "iterate";
  ExperimentViewConstants2["resolve"] = "resolve";
  return ExperimentViewConstants2;
})(ExperimentViewConstants || {});
export {
  DEFAULT_EXPERIMENT_NAME,
  DEFAULT_FEATURE_EXPOSURE_DURATION,
  ExperimentPivots,
  ExperimentViewConstants
};
//# sourceMappingURL=experiment.constants.js.map
